module.exports = "https://web-assets.ifttt.com/packs/media/icons/apple_appstore_download-7df32b1a.svg";